import { WEB_API_ROUTES } from 'api/api-routes';
import { apiWrapper } from '../../api/apiWrapper';
import { createThunk } from '../../utils/store-utils';

export const thunks = {
  getRoutinesList: createThunk('routines/getRoutinesList', (studentId) =>
    apiWrapper.get(WEB_API_ROUTES.routine.routineList, {
      params: {
        student_id: studentId,
      },
    })
  ),

  getRoutine: createThunk('routines/getRoutine', ({ routineId, studentId }) =>
    apiWrapper.get(
      WEB_API_ROUTES.routine.currentRoutine.replace('{routineId}', routineId),
      {
        params: {
          student_id: studentId,
        },
      }
    )
  ),
};
